export function cleanKmLabel(value: any, useDefaultDash = true): any {
  if (value === null || value === undefined) {
    return useDefaultDash ? '-' : '';
  }

  const strValue = String(value).trim();
  if (strValue === '') {
    return useDefaultDash ? '-' : '';
  }

  // Quitar todas las ocurrencias de "km" o "km/h"
  const cleaned = strValue.replace(/\s*(km\/?h?)\s*/gi, '').trim();

  // Si después de limpiar no queda nada, retornar 0
  if (cleaned === '') {
    return 0;
  }

  // Si lo limpiado es un número válido (entero o decimal), retornarlo como number
  if (/^-?\d+(\.\d+)?$/.test(cleaned)) {
    return parseFloat(cleaned);
  }

  // Si no es número, devolver el valor original tal cual (string)
  return strValue;
}
